import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 15C12.5523 15 13 14.5523 13 14V9C13 8.44771 12.5523 8 12 8C11.4477 8 11 8.44771 11 9V14C11 14.5523 11.4477 15 12 15Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.6738 17.5049L12.8688 5.56391C12.4852 4.89074 11.5148 4.89075 11.1312 5.56391L4.32621 17.5049C3.9463 18.1715 4.42773 19 5.19503 19H18.805C19.5723 19 20.0537 18.1715 19.6738 17.5049ZM14.6065 4.57365C13.4556 2.55416 10.5444 2.55416 9.39353 4.57365L2.58857 16.5146C1.44883 18.5146 2.89312 21 5.19503 21H18.805C21.1069 21 22.5512 18.5146 21.4114 16.5146L14.6065 4.57365Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }